const LAYOUT_HEADER_HEIGHT = 65;
const NAV_HEIGHT = 64;
const TABS_HEIGHT = 62;
const DOCUMENTS_PAGINATION_HEIGHT = 56;
const DOCUMENTS_TABLE_HEADER_HEIGHT = 100;

export const DOCUMENTS_HEIGHT_WITHOUT_TABLE =
  LAYOUT_HEADER_HEIGHT + NAV_HEIGHT + TABS_HEIGHT + DOCUMENTS_PAGINATION_HEIGHT + DOCUMENTS_TABLE_HEADER_HEIGHT;

